// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 9) return "static/css/9.87b6dda8.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}